<template>
  <section class="app-main" style="width: auto;">
    <router-view/>
  </section>
</template>
<script>
export default {
  name: 'AppMain'
}
</script>
<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 291px);
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/layout_pork_en/components/AppMain/index.vue